(function ($, window) {
    "use strict";
    DSV.ui.calculatorBox = {
        DOM: {
            formfields: {
                form: $('.volumetric-calculator__form'),
                stackableYes: $('#stackableYes'),
                length: $('#length'),
                width: $('#width'),
                height: $('#height'),
                conversionfactor: $('#conversionfactor'),
                conversionfactorLabel: $('.volumetric-calculator__conversion-factor label'),
                conversionfactorText: $('.volumetric-calculator__conversion-factor .unit > span'),
                submitbutton: $('.volumetric-calculator .submit-btn > input'),
                total: $('#total'),
                radioboxes: $('input[name=stackable]'),
                datafields: $('.volumetric-calculator .form-cols .col:nth-child(2)'),
                units: $('.volumetric-calculator .unit span[data-unittype^="unit--"]')
            },
            constants: {
                ldmfactor: $('.volumetric-calculator').attr('data-ldm'),
                ismetricunit: $('.volumetric-calculator').attr('data-metric'),
                requiredText: $('.volumetric-calculator').attr('data-requiredtext'),
                stackableLabel: $('.volumetric-calculator').attr('data-globalstckllabel') + $('.volumetric-calculator').attr('data-stckbllabel'),
                ldmLabel: $('.volumetric-calculator').attr('data-globalldmlabel') + $('.volumetric-calculator').attr('data-ldmlabel'),
                conversionfactorTextOriginalClone: $('.volumetric-calculator__conversion-factor .unit > span').clone().html(),
            },
        },
        /**
         * The metric / imperial units used
         */
        units: {
            metric: {
                lwh: 'cm',
                weight: 'kg',
                conversion: 'kg/m<sup>3</sup>',
                conversionLDM: 'kg/LDM'
            },
            imperial: {
                lwh: 'in',
                weight: 'lb',
                conversion: 'lb/in<sup>3</sup>',
                conversionLDM: 'lb/LDM'
            }
        },
        /**
         * State saved between stackable changes
         */
        savedState: {
            heightValue: undefined,
        },
        init: function () {
            var that = this;
            var firstValidationDone = false;

            this.DOM.formfields.form.on('keydown', function(e) {
                if (DSV.DOM.body.hasClass('experience-editor')) return;
                return that.controlCharacters(that, e)
            });
            this.DOM.formfields.form.on('keyup', function(e) {
                that.replaceCharacter(e);
            });
            this.DOM.formfields.submitbutton.click(function(e) {
                e.preventDefault();
                firstValidationDone = true;
                if (that.validateInputFields()) {
                    that.getResult();
                }
            });
            this.DOM.formfields.radioboxes.on('change', function(e){
                that.handleStackableChange(that, e);
                if (firstValidationDone) {
                    that.validateInputFields();
                }
            });

            DSV.DOM.window.on("resize", DSV.tools.throttle(this.setDatafieldWidth.bind(that), 250))
            
            setTimeout(() => {
                // Make sure it fires as the last tick
                this.setDatafieldWidth();
            }, 0);
            this.setUnitLabelsOnInit(that);
        },
        /**
         * Sets the Metric / Imperial unit labels
         */
        setUnitLabelsOnInit: function(that) {
            this.DOM.formfields.units.each(function(index, item) {
                switch($(item).attr('data-unittype')) {
                    case 'unit--lwh':
                        $(item).text(that.getUnit('lwh'));
                        break;
                    case 'unit--volumetric':
                        $(item).html(that.getUnit('conversion'));
                        break;
                    case 'unit--weight':
                        $(item).text(that.getUnit('weight'));
                        break;
                }
            })
        },
        /**
         * Sets the width of the input fields to the lowest common denominator
         */
        setDatafieldWidth: function() {
            if (window.innerWidth > 768) {
                var lowestWidth = undefined;
                // Find the lowest width number
                this.DOM.formfields.datafields.each(function(index, item) {
                    item.style.width = null; // Make sure previous styling is removed
                    if (lowestWidth === undefined) {
                        lowestWidth = item.offsetWidth;
                    } else if (lowestWidth > item.offsetWidth) {
                        lowestWidth = item.offsetWidth;
                    }
                });
                // Set the specific width
                this.DOM.formfields.datafields.each(function(index, item) {
                    item.style.width = lowestWidth + "px";
                });

                if (lowestWidth === 1280) { // If lowestWidth is still 1280, it means the DOM has not properly recalculated yet (ie11)
                    setTimeout(() => {
                        this.setDatafieldWidth();
                    }, 250);
                }
            } else {
                this.DOM.formfields.datafields.each(function(index, item) {
                    item.style.width = null;
                })
            }
        },
        /**
         * Prints the result to the DOM formatted
         * @param {number} newValue The result from the calculator
         */
        setResult: function(newValue) {
            // Updates the total value
            if (typeof newValue === "number")
                this.DOM.formfields.total.attr('value', newValue.toFixed(2) > 0 ? newValue.toFixed(2).replace(/\.00$/,'') : 0);
        },
        /**
         * 
         * @param {string} unit Returns the hardcoded unit text according to the shortcode
         * @returns {string}
         */
        getUnit: function(unit) {
            // Gets the unit
            // note: returns html (<sup></sup>) on converison
            // because of linebreaks
            if (this.DOM.constants.ismetricunit === "True") {
                switch(unit) {
                    case 'lwh':
                    return this.units.metric.lwh;
                    case 'weight':
                    return this.units.metric.weight;
                    case 'conversion':
                    return this.units.metric.conversion;
                    case 'conversionLDM':
                    return this.units.metric.conversionLDM;
                }
            } else {
                switch(unit) {
                    case 'lwh':
                    return this.units.imperial.lwh;
                    case 'weight':
                    return this.units.imperial.weight;
                    case 'conversion':
                    return this.units.imperial.conversion;
                    case 'conversionLDM':
                    return this.units.imperial.conversionLDM;
                }
            }
        },
        /**
         * Validates the four input fields, sets error class and returns true if all fields are valid
         * @returns {boolean}
         */
        validateInputFields: function() {
            // Sets errorclass on inputs and returns status
            var fields = [this.DOM.formfields.length, this.DOM.formfields.width, this.DOM.formfields.height, this.DOM.formfields.conversionfactor];
            var status = true;
            for (var i = 0; i < fields.length; i++) {
                fields[i].parent().removeClass('error');
                fields[i].attr('placeholder', null);
                // Prevent non-stackable calculator from validating disabled height
                if (
                    !this.DOM.formfields.stackableYes.is(':checked') 
                    && fields[i].attr('id') === "height") {
                    continue;
                } else if (fields[i].val().length === 0) {
                    status = false;
                    fields[i].parent().addClass('error');
                    fields[i].attr('placeholder', this.DOM.constants.requiredText);
                }
            };
            return status;
        },
        /**
         * Prevents 
         * @param {Event} e 
         * @returns {boolean}
         */
        controlCharacters: function(that, e) {
            var regex = /^[0-9.,]+$/;
            if (
                // Allow the regex, backspace, tab, delete, and left/right arrows
                e.key.match(regex) 
                || e.which === 8 
                || e.which === 9
                || e.which === 37 
                || e.which === 39 
                || e.which === 46
                || e.which === 13) {
                    // prevent if a dot or comma has already been entered
                    if (e.target.value && e.target.value.indexOf('.') != -1 && (e.which === 188 || e.which === 190)) {
                        return false
                    } else if (e.which === 13) {
                        // Validate and get result if the enter key is pressed
                        if (that.validateInputFields()) {
                            that.getResult();
                        }
                        return false;
                    } else {   
                        return true;
                    }
            } else {
                return false;
            }
        },
        /**
         * Replace every comma with a dot
         * @param {Event} e 
         */
        replaceCharacter: function(e) {
            // Replace every comma with a dot
            var input = e.target;
            if(input.tagName === "INPUT")
                input.value = input.value.split(',').join('.');
        },
        /**
         * Handle the radiobox click event for changing from stackable: no to stackable: yes and vice versa
         * @param {this} that 
         * @param {Event} e 
         */
        handleStackableChange: function(that, e) {
            if (e.target.id === "stackableNo") {
                that.DOM.formfields.height.attr('disabled', 'disabled');
                that.savedState.heightValue = that.DOM.formfields.height.val();
                that.DOM.formfields.height.val('')
                that.DOM.formfields.conversionfactorLabel.text(that.DOM.constants.ldmLabel);
                that.DOM.formfields.conversionfactorText.html(that.getUnit('conversionLDM'));
            } else if (e.target.id === "stackableYes") {
                that.DOM.formfields.height.removeAttr('disabled');
                that.DOM.formfields.conversionfactorLabel.text(that.DOM.constants.stackableLabel);
                if (that.savedState.heightValue) {
                    that.DOM.formfields.height.val(that.savedState.heightValue);
                }
                that.DOM.formfields.conversionfactorText.html(that.getUnit('conversion'));
            }
        },
        /**
         * Create JSON data to send to the API
         */
        makeJSONData: function() {
            var dataToSend = {};

            dataToSend.IsStackable = this.DOM.formfields.stackableYes.is(':checked') ? "true" : "false";
            dataToSend.Length = this.DOM.formfields.length.val();
            dataToSend.Width = this.DOM.formfields.width.val();
            dataToSend.Height = this.DOM.formfields.height.val() ? this.DOM.formfields.height.val() : "0";
            dataToSend.ConversionFactor = this.DOM.formfields.conversionfactor.val();
            dataToSend.LDM = this.DOM.constants.ldmfactor;

            return JSON.stringify(dataToSend);
        },
        /**
         * Fetch result
         */
        getResult: function() {
            var that = this;
            if (window.XMLHttpRequest) {
                $.ajax({
                    url: '/layouts/Handlers/VolumetricCalculator.ashx',
                    type: 'POST',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: this.makeJSONData(),
                    success: function(data, textStatus, jqXHR) {
                        that.setResult(data);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        console.log("Error status: " + jqXHR.statusText);
                    }
                })
            }
        }
    };
})(jQuery, window);